import InputLabelMUI, { InputLabelProps } from '@material-ui/core/InputLabel';

export const InputLabel: React.FC<InputLabelProps> = ({ children, ...rest }) => {
	return <InputLabelMUI {...rest}>{children}</InputLabelMUI>;
};
